/**
 * Detecção de alteração manual em conta — decide se o formulário pede a
 * justificativa ANTES de enviar. É só uma antecipação para não incomodar o
 * usuário à toa: quem decide de verdade é o servidor (422 em
 * `justificativa_alteracao`), depois das normalizações dele.
 */

export const JUSTIFICATIVA_MIN = 10;
export const CAMPO_JUSTIFICATIVA = 'justificativa_alteracao';

function texto(valor) {
    const t = valor === null || valor === undefined ? '' : String(valor).trim();
    return t === '' ? null : t;
}

function digitos(valor) {
    return texto(String(valor ?? '').replace(/\D/g, ''));
}

function numero(valor) {
    if (valor === null || valor === undefined || valor === '') return null;
    const n = Number(valor);
    return Number.isNaN(n) ? texto(valor) : n;
}

// DatePicker devolve Date; o que importa é o dia no relógio do usuário,
// não o instante (a mesma data pode vir 00:00Z do banco ou 12:00 local do parse).
function dia(valor) {
    if (!(valor instanceof Date) || Number.isNaN(valor.getTime())) return texto(valor);
    const p = (n) => String(n).padStart(2, '0');
    return `${valor.getFullYear()}-${p(valor.getMonth() + 1)}-${p(valor.getDate())}`;
}

/**
 * Só os campos que o usuário edita na tela. Campos de exibição (nome do
 * arquivo, usuário do upload) e o código de barras ficam de fora: upload e
 * remoção de arquivo já gravam no servidor na hora — compará-los faria pedir
 * justificativa para algo que o usuário não está salvando agora.
 * ponytail: lista fixa; campo novo editável no form precisa entrar aqui
 * (se esquecer, o 422 do servidor ainda abre o diálogo — só perde a antecipação).
 */
const CAMPOS = Object.freeze({
    tipo_conta: texto,
    tipo_cobranca: texto,
    contrato_id: texto,
    justificativa_preco: texto,
    valor: numero,
    data_vencimento: dia,
    data_pagamento: dia,
    observacao: texto,
    beneficiario_nome: texto,
    // A aba Beneficiário aplica máscara no CNPJ ao montar; só dígitos contam.
    beneficiario_cnpj: digitos,
});

export function retratoEditavel(form = {}) {
    return Object.fromEntries(
        Object.entries(CAMPOS).map(([campo, normalizar]) => [campo, normalizar(form[campo])]),
    );
}

export function formularioMudou(retratoOriginal, formAtual) {
    if (!retratoOriginal) return false;
    const atual = retratoEditavel(formAtual);
    return Object.keys(CAMPOS).some((campo) => atual[campo] !== retratoOriginal[campo]);
}

/**
 * Mensagem do servidor quando o 422 é SÓ pela justificativa; senão null.
 * Se houver outros campos inválidos, o fluxo normal de erro mostra-os primeiro —
 * no próximo salvar o diálogo aparece (o form continua "sujo").
 */
export function erroDeJustificativa(error) {
    if (error?.response?.status !== 422) return null;
    const data = error.response.data || {};
    const erros = data.erros ?? data.errors ?? {};
    const erro = erros[CAMPO_JUSTIFICATIVA];
    if (!erro || Object.keys(erros).length > 1) return null;
    return (Array.isArray(erro) ? erro[0] : erro) || 'Informe a justificativa da alteração.';
}
